import { render, staticRenderFns } from "./DiscussionComments.vue?vue&type=template&id=6a85c5f0&"
import script from "./DiscussionComments.vue?vue&type=script&lang=js&"
export * from "./DiscussionComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports